<template>
  <div>
    <div v-if="httpError && httpError.data" class="alert alert-danger">
      {{ httpError.data.error.message }}
    </div>

    <form method="post" @submit.prevent="handleFormSubmit">
      <div class="form-group">
        <label for="name">Tenant Name</label>
        <input
          id="name"
          name="name"
          type="name"
          v-model="tenantForm.name"
          v-validate="'required'"
          class="form-control"
        />
        <small v-if="veeErrors.has('name')" class="text-danger">
          {{ veeErrors.first("name") }}
        </small>
      </div>
      <div class="form-group">
        <label for="slug">Slug</label>
        <input
          id="slug"
          name="slug"
          class="form-control"
          :value="tenantForm.id"
          disabled="disabled"
        />
      </div>
      <div class="form-group">
        <label for="ownerEmail">Email</label>
        <input
          id="ownerEmail"
          v-model.trim="tenantForm.ownerEmail"
          v-validate="{ required: true }"
          name="ownerEmail"
          type="email"
          data-vv-as="email"
          class="form-control"
        />
        <small v-if="veeErrors.has('ownerEmail')" class="text-danger">
          {{ veeErrors.first("ownerEmail") }}
        </small>
      </div>
      <div class="row">
        <div class="col">
          <ActionButton
            type="submit"
            :theme="{
              primary,
              secondary,
              event,
              danger
            }"
            :disabled="isLoading || !!veeErrors.items.length"
            label="Save"
            style="width: auto; margin-left: auto; margin-top: 0;"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import serializeError from "serialize-error";
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/base";

export default {
  name: "EditTenant",
  components: {
    ActionButton
  },
  props: {
    tenant: {
      type: Object,
      default: () => {}
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: true,
      error: null,
      httpError: null,
      tenantForm: null
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    this.tenantForm = Object.assign({}, this.tenant);
  },
  mounted() {
    this.isLoading = false;
  },
  methods: {
    async handleFormSubmit() {
      this.handleErrorReset();
      this.isLoading = true;

      try {
        const isValid = await this.handleFormValidations();

        if (!isValid) {
          throw Error("Unable to validate form.");
        }

        // Send request
        const result = await axios.patch(
          `/tenants/${this.tenant.id}`,
          this.tenantForm
        );

        // Set new tenant details
        if (result.status === 200) {
          this.$toastr.success(`${this.tenantForm.name} has been added.`);
          this.$root.$emit("superadmin:fetchTenants", this.activeIndex);
        } else {
          this.$toastr.error("Unable to save tenant. Try again.");
        }

        this.$nextTick(() => {
          if (result.status === 200) {
            return this.$emit("close");
          }
          this.isLoading = false;
        });
      } catch (error) {
        const err = serializeError(error);
        if (err.response) {
          this.httpError = error;
        } else {
          this.error = err;
        }
        this.isLoading = false;
      }
    },
    handleFormValidations() {
      return this.$validator.validateAll().then(isValid => isValid);
    },
    handleErrorReset() {
      this.error = this.httpError = null;
    }
  }
};
</script>

<style lang="scss" scoped></style>
